export const FETCH_CONTRACTOR_INVOICES_REQUEST =
  'FETCH_CONTRACTOR_INVOICES_REQUEST';
export const FETCH_CONTRACTOR_INVOICES_SUCCESS =
  'FETCH_CONTRACTOR_INVOICES_SUCCESS';
export const FETCH_CONTRACTOR_INVOICES_FAIL = 'FETCH_CONTRACTOR_INVOICES_FAIL';

export const FETCH_CONTRACTOR_FINANCE_STATS_REQUEST =
  'FETCH_CONTRACTOR_FINANCE_STATS_REQUEST';
export const FETCH_CONTRACTOR_FINANCE_STATS_SUCCESS =
  'FETCH_CONTRACTOR_FINANCE_STATS_SUCCESS';
export const FETCH_CONTRACTOR_FINANCE_STATS_FAIL =
  'FETCH_CONTRACTOR_FINANCE_STATS_FAIL';

export const FETCH_CONTRACTOR_INVOICE_DETAIL_REQUEST =
  'FETCH_CONTRACTOR_INVOICE_DETAIL_REQUEST';
export const FETCH_CONTRACTOR_INVOICE_DETAIL_SUCCESS =
  'FETCH_CONTRACTOR_INVOICE_DETAIL_SUCCESS';
export const FETCH_CONTRACTOR_INVOICE_DETAIL_FAIL =
  'FETCH_CONTRACTOR_INVOICE_DETAIL_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_FAIL = 'UPDATE_CONTRACTOR_INVOICE_FAIL';

export const DELETE_CONTRACTOR_INVOICE_REQUEST =
  'DELETE_CONTRACTOR_INVOICE_REQUEST';
export const DELETE_CONTRACTOR_INVOICE_SUCCESS =
  'DELETE_CONTRACTOR_INVOICE_SUCCESS';
export const DELETE_CONTRACTOR_INVOICE_FAIL = 'DELETE_CONTRACTOR_INVOICE_FAIL';

export const CREATE_CONTRACTOR_INVOICE_RECEIPT_REQUEST =
  'CREATE_CONTRACTOR_INVOICE_RECEIPT_REQUEST';
export const CREATE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS =
  'CREATE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS';
export const CREATE_CONTRACTOR_INVOICE_RECEIPT_FAIL =
  'CREATE_CONTRACTOR_INVOICE_RECEIPT_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_RECEIPT_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_RECEIPT_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_RECEIPT_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_RECEIPT_FAIL';

export const DELETE_CONTRACTOR_INVOICE_RECEIPT_REQUEST =
  'DELETE_CONTRACTOR_INVOICE_RECEIPT_REQUEST';
export const DELETE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS =
  'DELETE_CONTRACTOR_INVOICE_RECEIPT_SUCCESS';
export const DELETE_CONTRACTOR_INVOICE_RECEIPT_FAIL =
  'DELETE_CONTRACTOR_INVOICE_RECEIPT_FAIL';

export const CREATE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST =
  'CREATE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST';
export const CREATE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS =
  'CREATE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS';
export const CREATE_CONTRACTOR_INVOICE_DOCUMENT_FAIL =
  'CREATE_CONTRACTOR_INVOICE_DOCUMENT_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_DOCUMENT_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_DOCUMENT_FAIL';

export const DELETE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST =
  'DELETE_CONTRACTOR_INVOICE_DOCUMENT_REQUEST';
export const DELETE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS =
  'DELETE_CONTRACTOR_INVOICE_DOCUMENT_SUCCESS';
export const DELETE_CONTRACTOR_INVOICE_DOCUMENT_FAIL =
  'DELETE_CONTRACTOR_INVOICE_DOCUMENT_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_SERVICE_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_SERVICE_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_SERVICE_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_SERVICE_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_SERVICE_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_SERVICE_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_BILL_FROM_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_BILL_FROM_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_BILL_FROM_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_BILL_FROM_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_BILL_FROM_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_BILL_FROM_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_BILL_TO_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_BILL_TO_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_BILL_TO_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_BILL_TO_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_BILL_TO_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_BILL_TO_FAIL';

export const SET_CONTRACTOR_INVOICE_NUMBER_REQUEST =
  'SET_CONTRACTOR_INVOICE_NUMBER_REQUEST';
export const SET_CONTRACTOR_INVOICE_NUMBER_SUCCESS =
  'SET_CONTRACTOR_INVOICE_NUMBER_SUCCESS';
export const SET_CONTRACTOR_INVOICE_NUMBER_FAIL =
  'SET_CONTRACTOR_INVOICE_NUMBER_FAIL';

export const SEND_CONTRACTOR_INVOICE_REQUEST =
  'SEND_CONTRACTOR_INVOICE_REQUEST';
export const SEND_CONTRACTOR_INVOICE_SUCCESS =
  'SEND_CONTRACTOR_INVOICE_SUCCESS';
export const SEND_CONTRACTOR_INVOICE_FAIL = 'SEND_CONTRACTOR_INVOICE_FAIL';

export const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_FAIL = 'CREATE_INVOICE_FAIL';

export const UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_REQUEST =
  'UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_REQUEST';
export const UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_SUCCESS =
  'UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_SUCCESS';
export const UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_FAIL =
  'UPDATE_CONTRACTOR_INVOICE_JOB_MEMO_FAIL';
